<template>
    <div>
        <InternalDossierForm v-if="showForm"
            isPatMode
            :patId="patId"
            :dossierReference="editDossierReference"
            :dossierType="editDossierType"
            :initialDraft="conversionDraft"
            @closeForm="closeForm" />

        <PatDossierList v-if="!showForm"
            :patId="patId"
            @closeForm="closeForm"
            @openForm="openForm"
            @editDossier="editForm"
            @openConversionDraft="openConversionDraft" />
    </div>
</template>

<script>
import InternalDossierForm from './InternalDossierForm.vue';
import PatDossierList from './PatDossierList.vue';

export default {
    components: {
        InternalDossierForm,
        PatDossierList
    },
    props: {
        patId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            showForm: false,
            editDossierReference: null,
            editDossierType: null,
            conversionDraft: null
        };
    },
    methods: {
        closeForm() {
            this.showForm = false;
            this.editDossierReference = null;
            this.editDossierType = null;
            this.conversionDraft = null;
        },
        openForm() {
            this.conversionDraft = null;
            this.showForm = true;
        },
        editForm({ reference, type }) {
            this.conversionDraft = null;
            this.editDossierReference = reference;
            this.editDossierType = type;
            this.showForm = true;
        },
        openConversionDraft(draft) {
            this.editDossierReference = null;
            this.editDossierType = null;
            this.conversionDraft = draft;
            this.showForm = true;
        }
    }
}
</script>
